import styled from 'styled-components';

const CalendarDaysView = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  div {
    font-size: 12px;
    line-height: 1em;
    text-align: center;
    color: var(--gray600);
    margin: 8px;
  }
`;

export default CalendarDaysView;



